"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * A lib to report event to sever
 *
 * 5 functions is exposed: init, setToken, report, register, unregister
 *
 * init: init asyncStats and create an eventQueue for send stats to sever cyclical
 * setToken: set token used for post stats
 * report: add event into eventQueue or report event immediately
 * register: register a request pattern into intercepter, any requests meet the pattern will be pushed into eventQueue
 * unregister: remove pattern registered in intercepter
 *
 * 1 status object is exposed: descriptionStatus
 */

if (!window._asyncStats) {
  window._asyncStats = {
    inited: false,
    // origin fetch function in window
    _fetch: window.fetch,
    // when a requst is triggered we go through all intercepter to see if isMatch(req) is true
    // if it is true then push metric into queue and call cb(). see function "register" for detail
    intercepter: {
      // [metricName]: {isMatch: () => boolean, cb: function}
    },
    // we saved all events into queue and send this queue by setInterval
    eventQueue: [
      // {metricName: string, description: 'success' | 'fail'}
    ]
  };
}
const descriptionStatus = {
  SUCCESS: 'success',
  FAIL: 'fail'
};

// modify fetch with intercepter
// any request meet intercepter's isMatch should be added into eventQueue
const _modifyFetch = () => {
  const {
    _fetch,
    intercepter
  } = window._asyncStats;
  window.fetch = async function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const response = await _fetch(...args);
    Object.entries(intercepter).forEach(_ref => {
      let [metricName, {
        isMatch,
        cb
      }] = _ref;
      if (isMatch(...args)) {
        console.log('metric test - add metric into queue: ', metricName);
        window._asyncStats.eventQueue.push({
          metricName,
          description: response.ok ? descriptionStatus.SUCCESS : descriptionStatus.FAIL
        });
        cb({
          res: response,
          req: args
        });
      }
    });
    return response;
  };
};

/**
 * send metrics to sever
 * @param {*} metrics
 */
const _sendMetrics = function () {
  let metrics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [
    // { metricName: string, description: 'success' | 'fail'}
  ];
  const {
    _fetch,
    apiOrigin,
    token
  } = window._asyncStats;
  const postData = [];
  metrics.forEach(_ref2 => {
    let {
      description = descriptionStatus.SUCCESS,
      metricName
    } = _ref2;
    // convert metrics from [{ metricName: string, description: 'success' | 'fail'}]
    // to postData: [{ metricName: string, description: 'success' | 'fail', count: number}]
    const metricData = postData.find(data => metricName === data.metricName && description === data.description);
    if (metricData) {
      metricData.count++;
    } else {
      postData.push({
        metricName,
        description,
        count: 1
      });
    }
  });
  _fetch(`${apiOrigin}/zasyncstats/v1/stats`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: token
    },
    credentials: 'include',
    method: 'POST',
    redirect: 'follow',
    body: JSON.stringify(postData)
  });
};

/**
 * Init asyncStats and setup interval
 * @param {string} apiOrigin - the origin when send stats, use window.location.origin by default
 * @param {number} timer - interval of clear eventQueue
 * @param {string} token - token when send stats
 */
const init = _ref3 => {
  let {
    apiOrigin = window.location.origin,
    timer = 60,
    token = ''
  } = _ref3;
  if (!window._asyncStats.inited) {
    Object.assign(window._asyncStats, {
      inited: true,
      apiOrigin,
      token
    });
    window.setInterval(() => {
      if (window._asyncStats.eventQueue.length) {
        _sendMetrics(window._asyncStats.eventQueue);
        window._asyncStats.eventQueue = [];
      }
    }, timer * 1000);
  }
};

/**
 * set token used for send stats
 * @param {string} token
 */
const setToken = _ref4 => {
  let {
    token = ''
  } = _ref4;
  window._asyncStats.token = token;
};

/**
 * add event into eventQueue or report event immediately
 * @param {string} description
 * @param {boolean} isImmediately
 * @param {string} metricName
 */
const report = _ref5 => {
  let {
    description = descriptionStatus.SUCCESS,
    isImmediately = false,
    metricName
  } = _ref5;
  if (!isImmediately) {
    window._asyncStats.eventQueue.push({
      metricName,
      description
    });
  } else {
    _sendMetrics([{
      metricName,
      description
    }]);
  }
};

/**
 * register a request pattern into intercepter, any requests meet the pattern will be pushed into eventQueue
 * @param {string} metricName
 * @param {func} isMatch
 * @param {func} cb
 */
const register = _ref6 => {
  let {
    metricName,
    isMatch,
    cb = () => {}
  } = _ref6;
  const asyncStats = window._asyncStats;
  if (asyncStats.intercepter[metricName]) {
    console.warn('you are overriding an existed event - ', metricName);
  }
  asyncStats.intercepter[metricName] = {
    isMatch,
    cb
  };
  // todo: support other request lib such as axois
  _modifyFetch();
};

// remove metricName in intercepter
const unregister = metricName => {
  delete window._asyncStats.intercepter[metricName];
  _modifyFetch();
};
const asyncStats = {
  init,
  setToken,
  report,
  register,
  unregister,
  descriptionStatus
};
var _default = exports.default = asyncStats;